import Vue from 'vue'
import Ionic from '@ionic/vue'
// import '@ionic/core/css/ionic.bundle.css'
import '../ionic-variables.css'

Vue.use(Ionic)
